import React from "react";
import { useNavigate } from "react-router-dom";
import { Mic2, Headphones, ArrowRight } from "lucide-react";
import { useSiteImages } from "../context/SiteImagesContext";
import { Logo } from "../components/Logo";

export default function Landing() {
  const nav = useNavigate();
  const { img } = useSiteImages();
  return (
    <div className="min-h-screen relative overflow-hidden flex flex-col">
      {/* Immersive artwork background */}
      <div className="pointer-events-none absolute inset-0">
        <img src={img("hero_desktop")} alt="" className="hidden sm:block absolute inset-0 w-full h-full object-cover opacity-45 animate-drift" />
        <img src={img("hero_mobile")} alt="" className="sm:hidden absolute inset-0 w-full h-full object-cover opacity-45" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/65 to-black" />
        <div className="absolute -top-1/3 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full blur-[150px] animate-drift"
          style={{ background: "radial-gradient(circle, rgba(109,25,255,0.30), transparent 62%)" }} />
        <div className="absolute bottom-[-10%] right-[-5%] w-[520px] h-[520px] rounded-full blur-[130px] animate-drift"
          style={{ background: "radial-gradient(circle, rgba(168,85,247,0.20), transparent 60%)", animationDelay: "3s" }} />
      </div>

      <header className="relative z-10 flex items-center justify-between px-5 sm:px-8 h-16">
        <Logo size={34} />
        <a href="/login" data-testid="nav-login" className="text-sm font-medium text-zinc-300 hover:text-white transition-colors">Connexion</a>
      </header>

      <main className="relative z-10 flex-1 flex flex-col items-center justify-center px-5 pb-20 text-center">
        <p className="font-mono text-[11px] sm:text-xs text-violet-300/80 tracking-[0.35em] uppercase mb-5 animate-fade-up">La plateforme des prods</p>
        <h1 className="font-display font-extrabold tracking-tighter leading-[0.88] text-6xl sm:text-7xl lg:text-8xl mb-12 animate-fade-up">
          ILOVE<span className="gradient-text">MUZIK</span>
        </h1>

        <div className="w-full max-w-3xl grid gap-4 sm:grid-cols-2 animate-fade-up" style={{ animationDelay: "0.1s" }}>
          <button onClick={() => nav("/start/artist")} data-testid="landing-hero-artist-cta"
            className="group relative overflow-hidden glass-card border border-violet-500/25 rounded-3xl p-8 sm:p-10 text-left hover:border-violet-400/70 hover:-translate-y-1 transition-all duration-300 hover:shadow-[0_0_50px_rgba(109,25,255,0.35)]">
            <div className="absolute -right-8 -top-8 w-40 h-40 rounded-full blur-3xl bg-violet-600/20 group-hover:bg-violet-500/40 transition-colors" />
            <Mic2 size={30} className="text-violet-300 mb-6 relative" />
            <h2 className="relative font-display font-extrabold text-4xl sm:text-5xl tracking-tight mb-2">ARTISTE</h2>
            <p className="relative text-sm text-zinc-400">Je recherche une prod</p>
            <ArrowRight size={20} className="relative mt-6 text-violet-300 group-hover:translate-x-2 transition-transform" />
          </button>

          <button onClick={() => nav("/start/beatmaker")} data-testid="landing-hero-beatmaker-cta"
            className="group relative overflow-hidden glass-card border border-violet-500/25 rounded-3xl p-8 sm:p-10 text-left hover:border-violet-400/70 hover:-translate-y-1 transition-all duration-300 hover:shadow-[0_0_50px_rgba(109,25,255,0.35)]">
            <div className="absolute -right-8 -top-8 w-40 h-40 rounded-full blur-3xl bg-fuchsia-600/20 group-hover:bg-fuchsia-500/40 transition-colors" />
            <Headphones size={30} className="text-violet-300 mb-6 relative" />
            <h2 className="relative font-display font-extrabold text-4xl sm:text-5xl tracking-tight mb-2">BEATMAKER</h2>
            <p className="relative text-sm text-zinc-400">Je propose mes prods</p>
            <ArrowRight size={20} className="relative mt-6 text-violet-300 group-hover:translate-x-2 transition-transform" />
          </button>
        </div>
      </main>
    </div>
  );
}
